export const camelToTitleCase = (text) => {
  const result = String(text).replace(/(?<=[a-z])([A-Z]|[0-9])|(?<=[0-9])([a-z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};
